<template>
    <div class="about">
        <headerCom></headerCom>
        <!-- <div class="top">
            <img src="../assets/images/about-top.png" alt="" />
            <div class="width nav-box">
                <img
                    src="../assets/images/logo-index.png"
                    class="logo"
                    alt=""
                    srcset=""
                />
            </div>
        </div> -->
        <div class="about-bg">
            <div class="bg1">
            <div class="width title-box">
                <p class="title">{{ article.title }}</p>
                <p class="date" v-if="article.publishTime">{{ article.publishTime.split(" ")[0] }}</p>
            </div>
            <div class="width list-box">
                <div class="detail-box" v-html="article.content"></div>
            </div>
            </div>
            <div class="width list-box">
                <div class="link-box">
                    <p v-if="lastArticle!=''" @click="linkTo('/newsDetail', lastArticle.id)">
                        上一篇：<span>{{ lastArticle.title }}</span>
                    </p>
                    <p v-if="nextArticle!=''"  @click="linkTo('/newsDetail', nextArticle.id)">
                        下一篇：<span>{{ nextArticle.title }}</span>
                    </p>
                </div>
            </div>
        </div>
        <!-- <img src="" alt="" srcset=""> -->
        <!-- <footerCom></footerCom> -->
    </div>
</template>
<script>
import footerCom from "../components/Footer";
import headerCom from "../components/header";
import { findById } from "../api/newsDetail.js";

export default {
    name: "newstendency",
    components: {
        footerCom,
        headerCom
    },
    data() {
        return {
            httpUrl: process.env.VUE_APP_URL,
            pagination: {
                pageSize: 10,
                currentPage: 1,
                total: null,
            },
            article: {},
            lastArticle: {},
            nextArticle: {},
        };
    },
    methods: {
        // 跳转
        linkTo(path, id) {
            this.$router.push({
                path: path,
                query: {
                    id: id,
                },
            });
            this.$nextTick(() => {
                this.$router.go(0);
            });
        },

        //列表
        findByIdFun() {
            findById({ id: this.$route.query.id })
                .then((res) => {
                    if (res.code == 200) {
                        this.article = res.data.article;
                        this.lastArticle = res.data.lastArticle;
                        this.nextArticle = res.data.nextArticle;
                    }
                })
                .catch((err) => {
                    this.$message(err.message);
                });
        },
    },
    created() {
        this.pagination.currentPage = 1;
        this.findByIdFun();
    },
};
</script>
<style lang="less" scoped>
.about-bg{
    background: #F8F8F8;
    // padding-top:90px;
    .bg1{
        background: #ffffff;
        border-top:10px #F8F8F8 solid;
    }
}
.about {
    .top {
        width: 100%;
        position: relative;
        .nav-box {
            position: absolute;
            top: 12px;
            left: 50%;
            transform: translateX(-50%);
            -webkit-transform: translateX(-50%); /* for Chrome || Safari */
            -moz-transform: translateX(-50%); /* for Firefox */
            -ms-transform: translateX(-50%); /* for IE */
            -o-transform: translateX(-50%); /* for Opera */
            height: 55px;
            z-index: 2000;
            padding-left: 20px;
            // padding-right: 50px;
            .logo {
                height: 55px;
                width: 137px;
                display: block;
                float: left;
            }
            color: #cccccc;
            font-size: 16px;
            .nav {
                float: right;
                height: 25px;
                line-height: 25px;
                margin-top: 15px;
                cursor: pointer;
                p {
                    float: left;
                    padding: 0 20px;
                }
            }
        }
    }

    .title-box {
        // position: relative;
        padding-top: 75px;
        padding-bottom: 25px;
        // border-bottom: 2px solid #d6dcea;
        p {
            text-align: center;
        }
        .title {
            margin-top: 25px;
            font-size: 26px;
            font-family: PingFang SC;
            font-weight: bold;
            color: #001111;
        }
        .date {
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #999999;
            margin: 25px 0;
        }
    }
    .list-box {
        // width: 100%;
        // padding-bottom: 100px;
        display: flex;
        flex-direction: column;

        .detail-box {
            width: 100%;
            line-height: 30px;
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #000000;
            padding-bottom:90px;
            min-height: 250px;
            p{
                font-size: 16px !important;
                span{
                    font-size: 16px !important;
                }
            }

            img {
                width: 100%;
                height: auto;
            }
        }

        .link-box {
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #666666;
            padding-bottom: 30px;
            margin-top: 90px;
            p {
                margin-bottom: 10px;
                cursor: pointer;
            }
        }
    }
}
/deep/ .el-pagination {
    margin-top: 50px;
    text-align: end;
}
@media screen and (max-width: 1650px) {
    .about .title-box .tips-box {
        font-size: 16px;
    }
    .about .title-box .tips-box img {
        width: 14px;
    }
}
@media screen and (max-width: 1450px) {
    .about .title-box .tips-box {
        font-size: 14px;
    }
    .about .title-box .tips-box img {
        width: 12px;
    }
}

/deep/.el-timeline-item__tail {
    // top: 50%;
    top: 0;
    left: 7px;
    padding-top: 10%;
    display: block !important;
}
/deep/ .el-timeline-item__node {
    top: calc(50% - 20px);
    background: url(../assets/images/line-time.png) no-repeat center center;
    background-size: 100% 100%;
    width: 18px;
    height: 18px;
    // margin-bottom: 10px;
}
</style>

<style>
.el-popper .popper__arrow::after {
    content: none;
}
.el-popper[x-placement^="bottom"] {
    margin-top: 0;
    margin-right: -30px;
    /* padding: 0 20px; */
}
.el-popper[x-placement^="bottom"] .popper__arrow {
    display: none;
}
.el-dropdown-menu {
    position: absolute;
    top: 0;
    left: 0;
    padding: 10px 0;
    margin: 0;
    background-color: rgba(0, 0, 0, 0.3);
    border: none;
    border-radius: 0;
    box-shadow: none;
}
.el-dropdown-menu__item {
    color: #ccc;
    width: 110px;
    text-align: center;
    background-color: rgba(0, 0, 0, 0) !important;
}
.el-dropdown-menu__item:hover {
    background-color: rgba(0, 0, 0, 0);
}
.el-dropdown-menu__item:focus {
    background-color: rgba(0, 0, 0, 0);
}
.el-dropdown {
    color: #ccc;
    font-size: 16px;
}
</style>

